import React from 'react';
import NFTModal from './NFTModal';
import { wcaseGif } from '../assets';

const WHATAKIT_MARKETPLACES = [
  {
    name: "SentX",
    url: "https://sentx.io/nft-marketplace/whatakit",
    priceKey: "sentx",
    displayNameKey: "sentxMarket"
  },
  {
    name: "Kabila",
    url: "https://market.kabila.app/collections/9219990/items",
    priceKey: "kabila",
    displayNameKey: "kabilaMarket"
  }
];

const WhataKitModal = ({ isOpen, onClose }) => (
  <NFTModal
    isOpen={isOpen}
    onClose={onClose}
    collectionKey="whatakit"
    image={wcaseGif}
    titleKey="modals.whataKitTitle"
    descKey="modals.whataKitDesc"
    benefitsKey="modals.whataKitBenefits"
    benefitsDescKey="modals.whataKitBenefitsDesc"
    benefitsIcon="💎"
    marketplaces={WHATAKIT_MARKETPLACES}
  />
);

export default WhataKitModal;
